import { render } from "./product-selling-plans.vue?vue&type=template&id=65caae57"
import script from "./product-selling-plans.vue?vue&type=script&lang=js"
export * from "./product-selling-plans.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Work/Sneak-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__